import React, { FC } from 'react';
import cx from 'classnames';

import { CardShow } from '@/components/renders';

import block from './block.json';
import { getStyles } from './styles.css';

export type ListShowsEventsProps = {
	title?: string;
	slug?: string;
	getStyles?: (styles: any) => string;
	events: Array<any>;
} & ChildrenProps;

/**
 * COMPONENT
 */
export const ListShowsEvents: FC<ListShowsEventsProps> & BlockConfigs = ({
	slug = block.slug,
	events = [],
}) => {
	const rootClass = cx(
		'supt-listCards',
		'supt-listCards--list-shows-events',
		getStyles()
	);

	return (
		events.length > 0 && (
			<div className={rootClass} data-block={slug}>
				{events.map((event, index) => (
					<CardShow
						key={index}
						{...event}
						categories={event.genres}
					/>
				))}
			</div>
		)
	);
};

ListShowsEvents.slug = block.slug;
ListShowsEvents.title = block.title;
